import React, { createContext, useState, useContext, useEffect } from 'react';

const UploadContext = createContext();

export const UploadProvider = ({ children }) => {
  const [uploadId, setUploadId] = useState(() => {
    // Initialize uploadId from localStorage if available
    return localStorage.getItem('uploadId') || null;
  });

  useEffect(() => {
    // Update localStorage whenever uploadId changes
    if (uploadId) {
      localStorage.setItem('uploadId', uploadId);
    } else {
      localStorage.removeItem('uploadId');
    }
  }, [uploadId]);

  return (
    <UploadContext.Provider value={{ uploadId, setUploadId }}>
      {children}
    </UploadContext.Provider>
  );
};

export const useUpload = () => {
  const context = useContext(UploadContext);
  if (!context) {
    throw new Error('useUpload must be used within an UploadProvider');
  }
  return context;
};